'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const RidingIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M15.6001 6.29999C16.4285 6.29999 17.1001 5.62842 17.1001 4.79999C17.1001 3.97156 16.4285 3.29999 15.6001 3.29999C14.7717 3.29999 14.1001 3.97156 14.1001 4.79999C14.1001 5.62842 14.7717 6.29999 15.6001 6.29999Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.6 9.70002H15.7L13.7 7.70002C13.3 7.30002 12.7 7.30002 12.3 7.70002L10.2 9.80002C9.80005 10.2 9.80005 10.8 10.2 11.2L12.2 13.2V17M20.2001 17.2C20.2001 18.9 18.9 20.2 17.2 20.2C15.5 20.2 14.2 18.9 14.2 17.2C14.2 15.5 15.5 14.2 17.2 14.2C18.9 14.2 20.2001 15.6 20.2001 17.2ZM6.80005 14.2C5.10005 14.2 3.80005 15.5 3.80005 17.2C3.80005 18.9 5.10005 20.2 6.80005 20.2C8.50005 20.2 9.80005 18.9 9.80005 17.2C9.80005 15.5 8.40005 14.2 6.80005 14.2Z",
          stroke: "currentColor"
        }
      )
    ]
  }
);
const VpRidingIcon = forwardRef(RidingIcon);

export { VpRidingIcon as default };
